<template>
  <div>
    <div class="top-bar">
      <!-- nav -->
      <div class="nav">
        <div class="nav-title">
          搜索
        </div>
      </div>
      <form action="/">
        <van-search
          v-model="keyword"
          placeholder="搜索插件名称"
          show-action
          @search="onSearch"
        >
          <div
            slot="action"
            class="search-back-text"
            @click="$router.$back()"
          >返回</div>
        </van-search>
      </form>
    </div>
    <via-plugin-list
      v-if="showResult"
      :height="listHeight"
      :refreshing.sync="refreshing"
      :loading.sync="loading"
      :finished="finished"
      :list="plugins"
      @refresh="refresh"
      @load="listLoad"
    />

    <van-skeleton
      v-if="searching"
      class="skeleton"
      title
      :row="10"
      :loading="true"
    />

  </div>
</template>

<script>
import { Search, Skeleton } from 'vant'
import ViaPluginList from 'components/common/via-plugin-list.vue'

export default {
  name: 'Search',
  components: {
    [Search.name]: Search,
    [Skeleton.name]: Skeleton,
    [ViaPluginList.name]: ViaPluginList
  },
  data() {
    return {
      keyword: '',
      showResult: false,
      currentPage: 0,
      refreshing: false,
      loading: false,
      finished: false,
      requesting: false,
      searching: false,
      plugins: []
    }
  },
  computed: {
    // rpx
    listHeight() {
      const navTitleHeight = 60
      const searchBar = 54
      const defaultHeight = this.$pxToRpx(this.$clientHeight)
      return defaultHeight - navTitleHeight - searchBar
    }
  },
  methods: {
    onSearch() {
      console.log('搜索' + this.keyword)
      this.searching = true
      this.currentPage = 0
      this.loading = false
      this.plugins = []
      this.showResult = false
      setTimeout(() => {
        this.showResult = true
        this.finished = false
      }, 1000)
    },
    refresh() {
      // 坑: finished从true变回false会立即加载一次, 所以记录旧的finished状态
      const isFinished = this.finished
      this.currentPage = 0
      this.loading = false
      this.finished = false
      this.plugins = []
      !isFinished && (this.listLoad())
    },
    listLoad() {
      if (this.finished) {
        return
      }
      if (this.requesting) {
        this.$toast.fail('点慢一点')
        return
      }
      this.requesting = true
      this.currentPage = this.currentPage + 1
      this.$api.plugin.findByName({ name: this.keyword, page: this.currentPage }).then(res => {
        this.loading = false
        this.requesting = false
        this.searching = false
        // 刷新成功
        if (this.refreshing) {
          this.$toast.success('刷新成功')
          this.refreshing = false
        }
        this.plugins = this.plugins.concat(res.data)
        if (!res.data || res.data.length < 20) {
          this.finished = true
        }
      }).catch(() => {
        if (this.refreshing) {
          this.$toast.fail('刷新失败')
          this.refreshing = false
        } else {
          this.$toast.fail('加载列表失败')
        }
        this.requesting = false
        this.loading = false
        this.searching = false
      })
    }
  }
}
</script>

<style scoped>
.top-bar {
    width: 375px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--light90);
}

/* nav */
.nav {
    width: 375px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
}
.nav-title {
    font-size: 30px;
    font-weight: 900;
    margin-left: 15px;
}

/* search */
.search-back-text {
    color: #969799;
}

.skeleton {
  margin-top: 15px;
}
</style>
